import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export type PhxUploadEvent = HttpEvent<any> & {
  id?: string;
  loaded?: number;
  total?: number;
  progress?: number;
};

@Injectable({ providedIn: 'root' })
export class PhxFileUploadS3Service {
  constructor(private readonly http: HttpClient) { }

  public uploadFile(url: string, file: File, identifier?: string): Observable<PhxUploadEvent> {
    const headers: HttpHeaders = new HttpHeaders({ 'Content-Type': file.type || 'application/octet-stream' });
    const req: HttpRequest<File> = new HttpRequest('PUT', url, file, { headers, reportProgress: true });
    return this.http.request(req).pipe(
      map((event: PhxUploadEvent): PhxUploadEvent => {
        if (event.type === HttpEventType.UploadProgress) {
          const loaded = event.loaded || 0;
          const total = event.total || file.size || 0;
          const progress = total ? Math.round((loaded / total) * 100) : 0;
          return { ...event, id: identifier, loaded, total, progress } as PhxUploadEvent;
        }
        return { ...event, id: identifier } as PhxUploadEvent;
      })
    );
  }
}
